export default __webpack_public_path__ + "static/media/Ellipse 4.73c69c44.svg";